(function () {
    window.addEventListener('load', function () {
        /* PBI - 23128  mobile */
        function switchCountry() {
            /* mobile button change location */
            var buttonMobile = document.querySelectorAll('.country-selector-spot .js-country-selector-goto');
            var countrySelectBox = document.querySelectorAll('.country-selector-spot .country-selector-spot__change__countries');

            if (buttonMobile.length > 0 && countrySelectBox.length > 0) {
                Array.prototype.forEach.call(buttonMobile, function (element) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        window.location.href = countrySelectBox[0].value;
                    });
                });         
            }
        }
        /* open  */
        function OpenCountrySelector() {
            var countrySelectorCountries = document.querySelectorAll('.countrySelectorCountries');
            var countrySelectorBlindshops = document.querySelectorAll('.countrySelectorBlindshops');
           
            Array.prototype.forEach.call(countrySelectorCountries, function (element) {
                element.addEventListener('click', function () {
                    openCountrySelectorTab(this);
                });
            });
            Array.prototype.forEach.call(countrySelectorBlindshops, function (element) {
                element.addEventListener('click', function () {
                    openCountrySelectorTab(this);
                });
            });
        }

        function scrollTop() {
            window.scrollTo({ top: 0, behavior: 'smooth' });
        }

        function openCountrySelectorTab(element) {
            
            var lastElement = document.querySelectorAll('#countrySelector .countrySelector > input');
            var firstElement = document.querySelector('#countrySelector .countrySelector').firstElementChild;
            var countrySelectorState = document.getElementById('selectCountryState');

            if (countrySelectorState) {
                countrySelectorState.checked = true;
                scrollTop();
            }
          if(element.dataset.tab){
              var input = document.querySelector(".regionListSelectorState[data-sid*='"+element.dataset.tab+"']");
              console.log(input,element.dataset.tab)
              if(input){
                  input.checked = true;
              }
            
          }else{

                //open last tab
                if (element.classList.contains('countrySelectorBlindshops')) {
                    lastElement[lastElement.length - 1].checked = true;
                }
                //open first tab
                if (element.classList.contains('countrySelectorCountries')) {
                    firstElement.checked = true;
                }
            }
        }

        function init() {
            var openCountrySelectorLinks = document.querySelectorAll('.js-openCountrySelector');

            if (openCountrySelectorLinks.length > 0) {
                Array.prototype.forEach.call(openCountrySelectorLinks, function (element) {
                    element.addEventListener('click', function (event) {
                        event.preventDefault();
                        openCountrySelectorTab(this);
                    });
                });
            }

            switchCountry();
            OpenCountrySelector();
        }


        init();
    }, false);
})();